import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as appActions from '../../App/actions'
import * as filtersActions from '../FiltersPanel/actions'

import ButtonNav from '../UI/ButtonNav'

import ReactModal from 'react-modal'
import { withRouter } from '../../helpers/withRouter.hoc'
import { googleLogout } from '@react-oauth/google'

class Sidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      key: null,
      modalIsOpen: false,
    }
  }

  componentDidMount = () => {
    this.props.setTasksLoading()
  }

  handleClickTime = () => {
    const { mode, switchTimeMoneyMode, setSettingsAppLoading, router } = this.props
    setSettingsAppLoading()
    if (
      router.location.pathname !== '/report' &&
      router.location.pathname !== '/timesheet'
    ) {
      if (mode === 'money') {
        switchTimeMoneyMode()
      }
    }
    if (window.location.pathname !== '/timesheet') {
      router.navigate('/timesheet')
    } else {
      this.props.resetDateRange()
      this.props.getReportTasksRequest()
    }
  }
  handleClickReport = () => {
    const { mode, switchTimeMoneyMode, setSettingsAppLoading, router } = this.props
    if (
      router.location.pathname !== '/report' &&
      router.location.pathname !== '/timesheet'
    ) {
      if (mode === 'money') {
        switchTimeMoneyMode()
      }
    }
    if (window.location.pathname !== '/report') {
      setSettingsAppLoading()
      router.navigate('/report')
    }
  }

  handleClickIntegrations = () => {
    const { setSettingsAppLoading } = this.props
    if (window.location.pathname !== '/integrations') {
      setSettingsAppLoading()
      this.props.router.navigate('/integrations')
    }
  }

  handleOpenModal = () => {
    this.setState({ modalIsOpen: true });
  };

  handleCloseModal = () => {
    this.props.clearError();
    this.setState({ modalIsOpen: false });
  };

  render() {
    const { logout, deleteAccount, error } = this.props
    const { timeSheetView, reportView, integrationsView } = {
      timeSheetView: window.location.pathname === '/timesheet',
      reportView: ['/timesheet', '/integrations'].indexOf(window.location.pathname) === -1,
      integrationsView: window.location.pathname === '/integrations',
    }
    const handleLogout = () => {
      logout()
      googleLogout()
    }
    return (
      <>
        <aside className='sidebar'>
          <ButtonNav
            timesheet
            active={timeSheetView}
            onClick={this.handleClickTime}
            title={'Time Sheet'}
          />
          <ButtonNav
            report
            active={reportView}
            onClick={this.handleClickReport}
            title={'Report'}
          />
          <ButtonNav
            integrations
            active={integrationsView}
            onClick={this.handleClickIntegrations}
            title={'Integrations'}
          />
          <ButtonNav
            remove
            active={false}
            style={{ marginTop: 'auto' }}
            title={'Delete account'}
            onClick={this.handleOpenModal}
          />
          <ButtonNav
            logout
            active={false}
            onClick={logout}
            title={'Log out'}
          >
            <div
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: '0',
                left: '0',
              }}
            ></div>
          </ButtonNav>
        </aside>

        <ReactModal isOpen={this.state.modalIsOpen} overlayClassName={'modal-overlay'} className={'modal'} onRequestClose={this.handleCloseModal}>
          <div className="modal-title">Delete your account</div>
          <div className="modal-text">
            <p>We're sorry you're leaving</p>
            <p>Your Timeflip data will be permanently lost if you delete your account.</p>
          </div>
          <div className="modal-actions">
            <button onClick={this.handleCloseModal}>Cancel</button>
            <button className="del-btn" onClick={deleteAccount}>Continue</button>
          </div>
          {error && (
            <div className="error">{error}</div>
          )}
        </ReactModal>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  mode: state.filtersPanel.tasksDisplayMode,
  error: state.app.error,
})

const mapDispatchToProps = (dispatch) => ({
  clearError: () => dispatch(appActions.clearError()),
  setTasksLoading: () => dispatch(appActions.setTasksLoading()),
  logout: () => dispatch(appActions.logout()),
  deleteAccount: () => dispatch(appActions.deleteAccount()),
  switchTimeMoneyMode: () => dispatch(filtersActions.switchTimeMoneyMode()),
  setSettingsAppLoading: () => dispatch(appActions.setSettingsAppLoading()),
  getReportTasksRequest: () => dispatch(appActions.getReportTasksRequest()),
  resetDateRange: () => dispatch(appActions.resetDateRange())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar))
